import React, { useState, useEffect } from "react";
import { Player } from "furioos-sdk";
import Popup from "./Popup";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import screenfull from "screenfull";

import Client2DSDK from "../utils/client-2d-sdk";

const CLIENT_PLAYER_LINK = process.env.REACT_APP_CLIENT_PLAYER_LINK || 'http://localhost';
const options = {
  whiteLabel: true,
  hideToolbar: true,
  hideTitle: true,
  hidePlayButton: false,
};

const containerId = 'client_2d_container';

const Client2DPlayer = ({ expiryMil, consumable, language }) => {
  const [popup, setPopup] = useState(false);
  const [open, setOpen] = useState(false);

  const handleCommandError = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const client2d = Client2DSDK(containerId, CLIENT_PLAYER_LINK, consumable.payload, language);
    
    setTimeout(function () {
      client2d.stop();
      setPopup(true);
    }, expiryMil);

    // Registers a callback and initiates a "ping" interval to check if the iframe is ready to receive messages.
    client2d.onCanReceiveMessage(() => {
      client2d.initialize(consumable.payload, language);
    });

    return () => {
      client2d.cleanup();
    }
  }, [consumable.payload, expiryMil]);
  
  return (
    <React.Fragment>
      {popup && (
        <Popup
          title={"Your Session Has Expired"}
          bodytext={
            "Please refresh the page or click on Reconnect to restart the session"
          }
        />
      )}
      <div
        variant="contained"
        id={containerId}
        style={{ height: "100%", backgroundColor: "#000000" }}
      ></div>
      <Snackbar
        open={open}
        onClose={handleClose}
        autoHideDuration={10000}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Alert onClose={handleClose} severity="warning" sx={{ width: "100%" }}>
          Please click on the game before using Keyboard Commands
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
}

export default Client2DPlayer;